import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Stack,
  Button,
} from "@mui/material";
import {
  CameraAltRounded as CameraAltRoundedIcon,
  Image as ImageIcon,
} from "@mui/icons-material";

// ─── Image Source Dialog ──────────────────────────────────────────────────────
const ImageSourceDialog = ({
  open,
  index,
  prefix = "",
  onClose,
  onTakePhoto,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{ sx: { borderRadius: 3, width: "100%", maxWidth: 300 } }}
  >
    <DialogTitle
      sx={{ textAlign: "center", pb: 1, fontSize: "1rem", fontWeight: 700 }}
    >
      Image Source
    </DialogTitle>
    <DialogContent sx={{ pb: 2 }}>
      <Stack spacing={1.5}>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<CameraAltRoundedIcon />}
          onClick={() => {
            onClose();
            // Live camera (webcam on desktop, device camera on mobile).
            onTakePhoto?.();
          }}
          sx={{ py: 1.5, borderRadius: 2 }}
        >
          Take Photo
        </Button>
        <Button
          fullWidth
          variant="outlined"
          startIcon={<ImageIcon />}
          onClick={() => {
            document.getElementById(`${prefix}gallery-input-${index}`)?.click();
            onClose();
          }}
          sx={{ py: 1.5, borderRadius: 2 }}
        >
          Choose from Gallery
        </Button>
      </Stack>
    </DialogContent>
  </Dialog>
);

export default ImageSourceDialog;
